<template>
  <!-- stavka liste "vreme (plavo) + naslov" (npr. Kalendar stocnih pijaca); stilovi liste: activity-feed iz teme -->
  <li class="feed-item">
    <NuxtLink :to="link">
      <p class="text-primary mb-1 font-size-12 text-uppercase">{{ event.description_time }}</p>
      <p class="mt-0 mb-0 font-size-16 text-dark">{{ event.title }}</p>
    </NuxtLink>
  </li>
</template>

<script setup>
const props = defineProps({
  event: { type: Object, required: true },
})

const { $srbTolat } = useNuxtApp()

const link = computed(() => ({
  name: 'kalendar-dogadjaja-event-title',
  params: {
    event: $srbTolat.srbTolat(props.event.category_name),
    title: $srbTolat.srbTolat(props.event.title),
  },
}))
</script>
